import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../translation.service';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { LearningCenterService } from '../../learning-center.service';
import { CommunicationsService } from '../../communications/communications.service';
import { Role } from '../../system-globals.service';

@Pipe({name: 'parseFilename'})
export class ParseFilenamePipe implements PipeTransform {
    transform(file: string): string {
        return file.split('/').pop();
    }
}

@Pipe({name: 'getDescription'})
export class GetDescriptionPipe implements PipeTransform {
    constructor (public translationService: TranslationService) {}

    transform(word: string): string {
        return this.translationService.getDescription(word);
    }
}

@Pipe({name: 'safe'})
export class SafePipe implements PipeTransform {

    constructor(protected sanitizer: DomSanitizer) {}

    public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}

@Pipe({name: 'getModuleNameFromId'})
export class GetModuleNameFromIdPipe implements PipeTransform {
    constructor (public learningCenterService: LearningCenterService) {}

    transform(moduleId: number): string {

        let name = this.learningCenterService.getModuleName(moduleId);

        if (!name) return 'Unknown Module';
        else return name;
    }
}

@Pipe({name: 'getMemoCategoryFromId'})
export class GetMemoCategoryFromIdPipe implements PipeTransform {
    constructor (private communicationsService: CommunicationsService) {}

    transform(categoryId: number): string {

        let name = this.communicationsService.getMemoCategoryName(+categoryId);

        if (!name) return 'Unknown Category';
        else return name;
    }
}

@Pipe({name: 'getMemoPriorityFromId'})
export class GetMemoPriorityFromIdPipe implements PipeTransform {
    constructor (private communicationsService: CommunicationsService) {}

    transform(priorityId: number): string {

        let name = this.communicationsService.getMemoPriorityName(+priorityId);

        if (!name) return 'Unknown Priority';
        else return name;
    }
}

@Pipe({name: 'getLearningCenterNameFromId'})
export class getLearningCenterNameFromIdPipe implements PipeTransform {
    constructor (public learningCenterService: LearningCenterService) {}

    transform(learningCenterId: number): string {
        let name = this.learningCenterService.getLearningCenterName(+learningCenterId);

        if (!name) return 'Unknown Learning Center';
        else return name;
    }
}

@Pipe({name: 'getRoleFromId'})
export class GetRoleFromIdPipe implements PipeTransform {
    transform(roleId: number): string {
        return Role[roleId].replace('_', ' ');
    }
}

@Pipe({name: 'htmlToPlaintext'})
export class HtmlToPlaintextPipe implements PipeTransform {
    transform(value: string): string {
        return value? value.replace(/<[^>]*>/g, '') : '';
    }
}


// @Pipe({name: 'convertNewlineToBr'})
// export class ConvertNewlineToBrPipe implements PipeTransform {
//     transform(html: string): string {
//         return html.replace(/(?:\r\n|\r|\n)/g, '<br>');
//     }
// }
